import { render, staticRenderFns } from "./AddUpdate.vue?vue&type=template&id=89c96606&"
import script from "./AddUpdate.vue?vue&type=script&lang=js&"
export * from "./AddUpdate.vue?vue&type=script&lang=js&"
import style0 from "./AddUpdate.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports